@if (errors.length > 0) {
  <div
    id="login-error"
    class="error-container">
    <h4>{{ 'error.login.title' | blah }}</h4>
    <p class="error-info">
      {{ 'error.login.info1' | blah }}
      <br>
        {{ 'error.login.info2' | blah }}
      </p>
      <div id="login-error-details"
        class="error-details">
        @for (error of errors; track error) {
          <div>
            {{error}}
          </div>
        }
      </div>
    </div>
  }